import { getRouteConfigForPath } from './utils';

const getBrowserPath = () =>
  window.location.pathname + (window.location.search || '');
export const connectChildAwareHistory = ({ router, routes }) => {
  router.subscribe(({ newPath, prevPath }) => {
    // The `router.go` call below will execute this function with a
    // `prevPath` of `null` once. Since this is the "initial route", we
    // want to `replaceState` rather than `pushState`. This prevents an
    // annoying back loop when coming into a route that was redirected.
    if (prevPath === null) {
      history.replaceState(null, null, newPath);
    } else if (
      newPath !== window.location.pathname &&
      (!isNavigatingWithinTheSameChild({ prevPath, newPath, routes }) ||
        shouldHandleChildRouting({ prevPath, newPath, routes }))
    ) {
      history.pushState(null, null, newPath);
    }
  });

  const handlePopState = () => {
    if (
      !isNavigatingWithinTheSameChild({
        prevPath: router.currentPath(),
        newPath: window.location.pathname,
        routes,
      }) ||
      shouldHandleChildRouting({
        prevPath: router.currentPath(),
        newPath: window.location.pathname,
        routes,
      })
    ) {
      router.go(getBrowserPath());
    }
  };
  window.addEventListener('popstate', handlePopState);

  const init = () => Promise.resolve().then(() => router.go(getBrowserPath()));

  return {
    init,
    disconnect: () => window.removeEventListener('popstate', handlePopState),
  };
};

export function isNavigatingWithinTheSameChild({ newPath, prevPath, routes }) {
  const routeConfigContainingNewPath = getRouteConfigForPath({
    path: newPath,
    routes,
  });
  const routeConfigContainingPrevPath = getRouteConfigForPath({
    path: prevPath,
    routes,
  });
  return routeConfigContainingNewPath === routeConfigContainingPrevPath;
}

function shouldHandleChildRouting({ prevPath, newPath, routes }) {
  const routeConfigContainingNewPath = getRouteConfigForPath({
    path: newPath,
    routes,
  });
  const routeConfigContainingPrevPath = getRouteConfigForPath({
    path: prevPath,
    routes,
  });
  return (
    routeConfigContainingNewPath === routeConfigContainingPrevPath &&
    routeConfigContainingNewPath.handleChildRouting === true
  );
}
